<div class="search-row">
  <div class="search-field search-field-large">
    <label class="form-label" for="">
      {{ "case.case-informations.member-fullname" | translate }}
    </label>
    <div class="search-container">
      <input
        type="text"
        class="form-control"
        [value]="readonlyDatas.fullname"
        readonly
        [placeholder]="'patient-card.search-input' | translate"
      />
      <div class="icon-container">
        <button
          class="icon-button"
          (click)="clearSearch()"
          *ngIf="readonlyDatas.fullname"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <button *ngIf="!isReadOnly"  class="icon-button" (click)="search()">
          <i class="fa-solid fa-magnifying-glass"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="search-field search-field-small">
    <label class="form-label" for="">
      {{ "case.case-informations.member-id" | translate }}
    </label>
    <app-readonly-input [value]="readonlyDatas?.memberNo?.toString()"></app-readonly-input>
  </div>

  <div class="search-field search-field-small">
    <label class="form-label" for="">
      {{ "case.case-informations.contract-no" | translate }}
    </label>
    <app-readonly-input [value]="readonlyDatas?.contractNo?.toString()"></app-readonly-input>
  </div>
</div>

<p-dialog
  [header]="'definition.member.select-header' | translate"
  [(visible)]="isOpen"
  [modal]="true"
  [style]="{ width: '80vw' }"
  (onHide)="onHide()"
  appendTo="body"
>
  <div class="row">
    <div class="col-xl-12 active-p">
      <div class="row">
        <div class="col-xl-3 col-sm-6 mb-3">
          <label for="">{{ "definition.member.name" | translate }}</label>
          <input
            type="text"
            [(ngModel)]="filter.name"
            class="form-control"
            [placeholder]="'definition.member.name' | translate"
          />
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
          <label for="">{{ "definition.member.surname" | translate }}</label>

          <input
            type="text"
            [(ngModel)]="filter.surname"
            class="form-control"
            [placeholder]="'definition.member.surname' | translate"
          />
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
          <label for="">{{ "definition.member.id_no" | translate }}</label>

          <input
            type="text"
            [(ngModel)]="filter.idNumber"
            class="form-control"
            [placeholder]="'definition.member.id_no' | translate"
          />
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
          <label for="">{{ "definition.member.phone" | translate }}</label>

          <input
            type="tel"
            [(ngModel)]="filter.phoneNumber"
            class="form-control"
            placeholder="xxx-xxx-xx-xx"
            pattern="\d{3}-\d{3}-\d{2}-\d{2}"
            appPreventNegativeInput
            [min]="0"
          />
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
          <label for="">{{ "definition.member.member_no" | translate }}</label>

          <input
            type="number"
            [(ngModel)]="filter.member_id"
            class="form-control"
            [placeholder]="'definition.member.member_no' | translate"
          />
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
          <label for="">{{ "definition.member.contract_no" | translate }}</label>

          <input
            type="number"
            [(ngModel)]="filter.contract_id"
            class="form-control"
            [placeholder]="'definition.member.contract_no' | translate"
          />
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
          <label for="">{{ "common.activity" | translate }}</label>

          <p-dropdown
            [options]="contractStatuses"
            [filter]="false"
            appendTo="body"
            [showClear]="true"
            [placeholder]="'common.activity' | translate"
            [(ngModel)]="filter.contract_status"
          ></p-dropdown>
        </div>
        <div class="col-12 d-flex justify-content-end mt-3">
          <button
            class="btn btn-danger light"
            (click)="clearFilters()"
            type="button"
          >
            {{ "general.clear-filter" | translate }}
          </button>
          <button
            (click)="onFilterClick()"
            class="btn btn-info ms-2"
            type="button"
          >
            {{ "general.filtering" | translate }}
            <i class="fa fa-search ms-2"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        <div class="data-table-header-container">
          <div class="data-table-header text-center font-weight-bold">
            {{ "definition.member.main-info" | translate }}
          </div>
        </div>
        <div class="table-responsive active-projects user-tbl dt-filter">
          <div id="user-tbl_wrapper" class="dataTables_wrapper no-footer">
            <p-table
              [value]="filteredMembers"
              *ngIf="isOpen"
              responsiveLayout="stack"
              [(selection)]="selectedMember"
              [rowHover]="true"
              [scrollable]="true"
              scrollHeight="15rem"
              dataKey="uyelik_id"
              selectionMode="single"
              [tableStyle]="{ width: '100%' }"
              (onLazyLoad)="loadData($event)"
              [rowsPerPageOptions]="[20, 30, 40]"
              paginatorDropdownAppendTo="body"
              [first]="first"
              [rows]="rows"
              [lazy]="true"
              [totalRecords]="totalRecords"
              [paginator]="true"
              (onRowUnselect)="memberChange($event)"
              (onRowSelect)="memberChange($event)"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 33%" scope="col">
                    <span class="p-column-title"
                      >{{ "definition.member.name" | translate }}
                      {{ "definition.member.surname" | translate }}
                    </span>
                  </th>

                  <th style="width: 33%" scope="col">
                    <span class="p-column-title"
                      >{{ "definition.member.tc_kimlik_no" | translate }}
                    </span>
                  </th>
                  <th style="width: 33%" scope="col">
                    <span class="p-column-title"
                      >{{ "definition.member.member_no" | translate }}
                    </span>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-member>
                <tr [pSelectableRow]="member" style="height: 4rem">
                  <td>{{ member?.fullname }}</td>
                  <td>{{ member?.tc_kimlik_no }}</td>
                  <td>{{ member?.uyelik_id }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="paginatorleft">
                {{ totalRecords }} {{ "common.table.totalFound" | translate }}
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="9">{{ "common.noData" | translate }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>

      <div class="col-xl-1">
        <p-divider layout="vertical"> </p-divider>
      </div>
      <div class="col-md-6">
        <div class="data-table-header-container">
          <div class="data-table-header text-center font-weight-bold">
            {{ "definition.member.sub-info" | translate }}
          </div>
        </div>
        <div class="table-responsive active-projects user-tbl dt-filter">
          <div class="dataTables_wrapper no-footer">
            <p-table
              [value]="selectedMember?.serviceDetails"
              responsiveLayout="stack"
               selectionMode="single"
              [(selection)]="selectedMemberDetail"
              [rowHover]="true"
              [scrollable]="true"
              scrollHeight="15rem"
              [tableStyle]="{ width: '100%' }"
              dataKey="sozlesme_id"
              [totalRecords]="totalRecords"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 20%" scope="col">
                    <span class="p-column-title"
                      >{{ "definition.member.detail.package-name" | translate }}
                    </span>
                  </th>

                  <th style="width: 20%" scope="col">
                    <span class="p-column-title"
                      >{{ "definition.member.detail.contract_no" | translate }}
                    </span>
                  </th>

                  <th style="width: 20%" scope="col">
                    <span class="p-column-title"
                      >{{ "definition.member.detail.start-date" | translate }}
                    </span>
                  </th>

                  <th style="width: 20%" scope="col">
                    <span class="p-column-title"
                      >{{ "definition.member.detail.end-date" | translate }}
                    </span>
                  </th>

                  <th style="width: 20%" scope="col">
                    <span class="p-column-title"
                      >{{
                        "definition.member.detail.contract-status" | translate
                      }}
                    </span>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-memberDetail>
                <tr style="height: 4rem" [pSelectableRow]="memberDetail">
                  <td>{{ memberDetail?.paket_adi }}</td>
                  <td>{{ memberDetail?.sozlesme_id }}</td>
                  <td>{{ memberDetail?.baslangic_tarihi }}</td>
                  <td>{{ memberDetail?.bitis_tarihi }}</td>
                  <td>
                    <span
                      class="badge light border-0 badge-{{
                        memberDetail?.sozlesme_durumu === 'Aktif'
                          ? 'success'
                          : 'danger'
                      }}"
                    >
                      {{ memberDetail?.sozlesme_durumu }}
                    </span>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="9">{{ "common.noData" | translate }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex align-items-center">
      <div>
        <button class="btn btn-danger me-2" (click)="isOpen = false">
          {{ "common.cancel" | translate }}
        </button>
        <button
          class="btn btn-success"
          [disabled]="!selectedMemberDetail"
          (click)="confirmSelection()"
        >
          {{ "patient-card.continue" | translate }}
        </button>
      </div>
    </div>
  </ng-template>
  <app-loading [fullScreen]="true" [loading]="loading"></app-loading>
</p-dialog>
